/**
 *
 * Load scribe ad script which will insert an ad element
 * Depends on monolith script
 *
 * @author Rajat Ashok      <rashok@wayfair.com>
 * @author Seraphina Orsini <sorsini@wayfair.com>
 * @copyright 2020 Wayfair LLC - All rights reserved
 */
import $ from 'jquery';

const MONOLITH_ADS_FILE =
  'https://secure.img1-fg.wfcdn.com/st4/scribe/scribe_ads.js';
const AD_CONTAINER = 'ad-container';

const isAdBlockerEnabled = () =>
  new Promise(resolve => {
    $.getScript(MONOLITH_ADS_FILE)
      .done(() => {
        const adElement = document.getElementById(AD_CONTAINER);
        if (typeof adElement === `undefined`) {
          resolve(true);
        } else {
          document.body.removeChild(adElement);
          resolve(false);
        }
      })
      .fail(() => {
        resolve(true);
      });
  });

export default isAdBlockerEnabled;
